import { api } from '@/lib/api/axios';
import type { BookingAvailabilityResponseDto } from '@/types/dto/BookingAvailabilityResponse.dto';
import type {
  BookingDetailResponseDto,
  BookingListSection,
  CreateBookingRequestDto,
  CreateBookingResponseDto,
  ProfileBookingsResponseDto,
} from '@/types/dto/booking.dto';

function serializeQueryParams(params: Record<string, string | string[]>) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(key, item);
      });
      return;
    }

    searchParams.append(key, value);
  });

  return searchParams.toString();
}

export const BookingService = {
  create: async (payload: CreateBookingRequestDto): Promise<CreateBookingResponseDto> => {
    const { data } = await api.post<CreateBookingResponseDto>('/booking', payload);

    return data;
  },
  getAvailability: async (
    companyId: string,
    serviceIds: string[],
    professionalId: string,
    cursor?: string | null,
  ): Promise<BookingAvailabilityResponseDto> => {
    const queryParams: Record<string, string | string[]> = {
      companyId,
      professionalId,
      serviceIds,
    };

    if (cursor) {
      queryParams.cursor = cursor;
    }

    const queryString = serializeQueryParams(queryParams);
    const { data } = await api.get<BookingAvailabilityResponseDto>(`/booking/availability?${queryString}`);

    return data;
  },
  list: async (section: BookingListSection): Promise<ProfileBookingsResponseDto> => {
    const { data } = await api.get<ProfileBookingsResponseDto>('/booking', {
      params: { section },
    });

    return data;
  },
  detail: async (bookingId: string): Promise<BookingDetailResponseDto> => {
    const { data } = await api.get<BookingDetailResponseDto>(`/booking/${bookingId}`);

    return data;
  },
  confirm: async (bookingId: string): Promise<void> => {
    await api.patch(`/booking/${bookingId}/confirm`);
  },
  cancel: async (bookingId: string): Promise<void> => {
    await api.patch(`/booking/${bookingId}/cancel`);
  },
};
